// Gathers all repository data for a manuscript into a single backup payload

import type { Manuscript, PlannerStructure, CodexEntry, Goals, FormatSettings, SceneContent, Series, Collection } from '@/types/database';
import type { DataRepository } from '@/types/repository';
import { androidRepository } from '@/lib/repository/androidRepository';

export interface ManuscriptBackupPayload {
  manuscript: Manuscript | undefined;
  plannerStructure: PlannerStructure | undefined;
  codexEntries: CodexEntry[];
  goals: Goals | undefined;
  formatSettings: FormatSettings | undefined;
  sceneContent: Pick<SceneContent, 'id' | 'manuscriptId' | 'content'>[];
  series?: Series | undefined;
  collection?: Collection | undefined;
}

export async function gatherBackupPayload(
  manuscriptId: string,
  repository: DataRepository = androidRepository
): Promise<ManuscriptBackupPayload> {
  const [manuscript, plannerStructure, codexEntries, goals, formatSettings, sceneContent] =
    await Promise.all([
      repository.getManuscript(manuscriptId),
      repository.getPlannerStructure(manuscriptId),
      repository.getCodexEntriesForManuscript(manuscriptId),
      repository.getGoals(manuscriptId),
      repository.getFormatSettings(manuscriptId),
      repository.getAllSceneContentForManuscript(manuscriptId),
    ]);

  const series = manuscript?.seriesId ? await repository.getSeries(manuscript.seriesId) : undefined;
  const collection = manuscript?.collectionId ? await repository.getCollection(manuscript.collectionId) : undefined;

  return {
    manuscript,
    plannerStructure,
    codexEntries,
    goals,
    formatSettings,
    sceneContent,
    series,
    collection,
  };
}
